export default [
  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/login'
    }
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      `@/pages/Login.vue`
    )
  },
  {
    path: '/',
    meta: { },
    name: 'Root',
    redirect: {
      name: 'Login'
    }
  },
  {
    path: '/delivery',
    name: 'Delivery',
    component: () => import(
      `@/pages/Delivery.vue`
    ),
    redirect: {
      path: '/delivery/home',
    },
    children: [
      {
        path: '/delivery/home',
        name: 'Home',
        component: () => import(
          `@/pages/home/Home.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },
      {
        path: '/delivery/pedidos',
        name: 'Pedidos',
        component: () => import(
          `@/pages/pedido/Lista.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },
      {
        path: '/delivery/meus-dados',
        name: 'MeusDados',
        component: () => import(
          `@/pages/MeusDados.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },
      {
        path: '/delivery/relatorio',
        name: 'Relatorio',
        component: () => import(
          `@/pages/relatorio/Resumo.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },
      {
        path: '/delivery/relatorio/pedidos',
        name: 'RelatorioPedidos',
        component: () => import(
          `@/pages/relatorio/Lista.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },
      {
        path: '/delivery/financeiro',
        name: 'Financeiro',
        component: () => import(
          `@/pages/financeiro/Resumo.vue`
        ),
        meta: { perfis: ['administrador'] },
      },
      {
        path: '/delivery/financeiro/boleto',
        name: 'Boleto',
        component: () => import(
          `@/pages/financeiro/boleto/Lista.vue`
        ),
        meta: { perfis: ['administrador'] },
      },
      {
        path: '/delivery/avaliacoes',
        name: 'Avaliacoes',
        component: () => import(
          `@/pages/avaliacao/Lista.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },
      {
        path: '/delivery/horario',
        name: 'Horario',
        component: () => import(
          `@/pages/horario/Lista.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },
      {
        path: '/delivery/entrega',
        name: 'Entrega',
        component: () => import(
          `@/pages/entrega/Lista.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },
      {
        path: '/delivery/pagamento',
        name: 'Pagamento',
        component: () => import(
          `@/pages/pagamento/Lista.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },
      {
        path: '/delivery/cardapio/',
        name: 'Cardapio',
        component: () => import(
          `@/pages/cardapio/Cadastro.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },
      {
        path: '/delivery/marketing',
        name: 'Marketing',
        component: () => import(
          `@/pages/marketing/Marketing.vue`
        ),
        meta: { perfis: ['administrador'] },
      },
      {
        path: '/delivery/cupom-desconto',
        name: 'cupomDesconto',
        component: () => import(
          `@/pages/cupom-desconto/Lista.vue`
        ),
        meta: { perfis: ['administrador'] },
      },
      {
        path: '/delivery/marketing/campanhas',
        name: 'CampanhaPromocao',
        component: () => import(
          `@/pages/marketing/CampanhaPromocao.vue`
        ),
        meta: { perfis: ['administrador'] },
      },
      {
        path: '/delivery/notificacao',
        name: 'Notificacao',
        component: () => import(
          `@/pages/notificacao/Lista.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },
      {
        path: '/delivery/configuracoes',
        name: 'Configuracao',
        component: () => import(
          `@/pages/configuracao/Editar.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },
      {
        path: '/delivery/perguntas-frequentes',
        name: 'perguntasFrequentes',
        component: () => import(
          `@/pages/perguntas/Lista.vue`
        ),
        meta: { perfis: ['administrador', 'atendente'] },
      },

    ]
  },
];
